import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';
import { pathData } from './path-data';

export interface ReemaIconComponentProps
  extends Omit<SvgIconProps, 'width' | 'height' | 'color'> {
  color?: SvgIconProps['htmlColor'];
  gradientColors?: string[];
  useGradient?: boolean;
  width?: string | number;
  height?: string | number;
  verticalAlign?: 'middle' | 'top' | 'bottom';
  opacity?: number;
  transition?: string;
}

export const ReemaIconComponent = ({
  color,
  gradientColors,
  useGradient = false,
  width = '100%',
  height = '100%',
  verticalAlign = 'middle',
  opacity = 1,
  transition = 'none',
  sx,
  ...props
}: ReemaIconComponentProps) => {
  const theme = useTheme();
  const defaultColor = theme.palette.primaryAccent.main;

  let gradientArray = gradientColors;
  if (useGradient && !gradientColors) {
    gradientArray = ['#FF6B6B', '#4ECDC4'];
  }

  const viewBox = '0 0 126 124';
  const gradientId = 'reemaIconGradient';

  return (
    <SvgIcon
      {...props}
      viewBox={viewBox}
      sx={{
        color: color || defaultColor,
        width,
        height,
        verticalAlign,
        opacity,
        transition,
        ...sx,
      }}
    >
      {useGradient && (
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
            {gradientArray.map((color, index) => {
              const offset =
                gradientArray.length === 1
                  ? 0
                  : (index * 100) / (gradientArray.length - 1);
              return (
                <stop key={index} offset={`${offset}%`} stopColor={color} />
              );
            })}
          </linearGradient>
        </defs>
      )}
      <path
        d={pathData}
        fill={useGradient ? `url(#${gradientId})` : 'currentColor'}
      />
    </SvgIcon>
  );
};
